const BACKEND_MASK_FACTOR = 552421

export function unmaskMaskedId(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null
  }

  const numeric = typeof value === 'number' ? value : Number(String(value).trim())
  if (!Number.isFinite(numeric) || numeric <= 0) {
    return null
  }

  const unmasked = numeric / BACKEND_MASK_FACTOR
  return Number.isInteger(unmasked) ? unmasked : null
}